import { Capacitor } from "@capacitor/core";

/** True solo nell'app Android/iOS Velta One, non nel browser. */
export function isVeltaApk() {
  try {
    return !!Capacitor.isNativePlatform?.();
  } catch {
    return false;
  }
}

export function staffHomePath(user) {
  const perms = Array.isArray(user?.permissions) ? user.permissions : [];
  if (perms.includes("appuntamenti")) return "/dashboard/appuntamenti";
  if (perms.includes("magazzino")) return "/dashboard/magazzino";
  if (perms.includes("statistiche")) return "/dashboard/statistiche";
  if (perms.includes("gestionale")) return "/dashboard";
  if (perms.includes("fatturazione")) return "/dashboard/fatturazione";
  if (perms.includes("palmare")) return "/palmare";
  if (perms.includes("cassa")) return "/cassa";
  return "/login";
}

const DASH_RULES = [
  { match: (p) => p === "/dashboard" || p === "/dashboard/", perm: "gestionale" },
  { match: (p) => p.startsWith("/dashboard/appuntamenti"), perm: "appuntamenti" },
  { match: (p) => p.startsWith("/dashboard/prenotazioni"), perm: "gestionale" },
  { match: (p) => p.startsWith("/dashboard/reminder"), perm: "appuntamenti" },
  { match: (p) => p.startsWith("/dashboard/magazzino"), perm: "magazzino" },
  { match: (p) => p.startsWith("/dashboard/statistiche") || p.startsWith("/dashboard/vendite") || p.startsWith("/dashboard/report-"), perm: "statistiche" },
  { match: (p) => p.startsWith("/dashboard/chiusure"), perm: "statistiche" },
  { match: (p) => p.startsWith("/dashboard/documenti") || p.startsWith("/dashboard/storni"), perm: "chiusura_fiscale" },
  { match: (p) => p.startsWith("/dashboard/articoli") || p.startsWith("/dashboard/tavoli") || p.startsWith("/dashboard/fedelta") || p.startsWith("/dashboard/conti-aperti") || p.startsWith("/dashboard/movimenti-gestionali") || p.startsWith("/dashboard/alberghiero") || p.startsWith("/dashboard/gelateria") || p.startsWith("/dashboard/abbonamento") || p.startsWith("/dashboard/sistema"), perm: "gestionale" },
  { match: (p) => p.startsWith("/dashboard/stampanti"), perm: "stampanti" },
  { match: (p) => p.startsWith("/dashboard/fatturazione"), perm: "fatturazione" },
  { match: (p) => p.startsWith("/dashboard/esportazioni"), perm: "esportazioni" },
  { match: (p) => p.startsWith("/dashboard/messaggi"), perm: "gestionale" },
  { match: (p) => p.startsWith("/dashboard/branding"), perm: "branding" },
  { match: (p) => p.startsWith("/dashboard/utenti"), perm: "utenti" },
  { match: (p) => p.startsWith("/dashboard/punti-vendita"), perm: "__owner__" },
];

export function staffCanOpenDashboardPath(pathname, perms) {
  const list = Array.isArray(perms) ? perms : [];
  const rule = DASH_RULES.find((r) => r.match(pathname));
  if (!rule) return list.includes("gestionale");
  if (rule.perm === "__owner__") return false;
  return list.includes(rule.perm);
}
